import { render } from "./LoanOfficerAssistantDashboard.vue?vue&type=template&id=4ebd3dc4&scoped=true"
import script from "./LoanOfficerAssistantDashboard.vue?vue&type=script&lang=js"
export * from "./LoanOfficerAssistantDashboard.vue?vue&type=script&lang=js"

import "@/assets/css/commandcenter/commandcenter.css?vue&type=style&index=0&lang=css&external"
import "./LoanOfficerAssistantDashboard.vue?vue&type=style&index=1&id=4ebd3dc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ebd3dc4"]])

export default __exports__